export default __webpack_public_path__ + "static/media/a4.7184315a.svg";